import React from 'react'

import { ListRooms } from './list-rooms.component'

export const HomePage: React.FC = () => {
  return <ListRooms />
}
